import { Card, Tabs } from "antd";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import AddressTab from "./AddressTab";
import AppInformationTab from './AppInformationTab';

const UserSettings = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [activeTabKey, setActiveTabKey] = React.useState(searchParams.get("tab") || "address");

	useEffect(() => {
		document.title = "Pengaturan Pengguna - Cloudiva";
	}, []);

	return (
		<Card>
			<Tabs
				activeKey={activeTabKey}
				onChange={(key) => {
					setActiveTabKey(key);
					setSearchParams({ tab: key });
				}}
				type="card"
				size="middle"
				tabPosition="left"
				items={[
					// {
					// 	key: "general",
					// 	label: "Pengaturan Umum",
					// },
					{
						key: "address",
						label: "Alamat",
						children: <AddressTab />,
					},
					{
						key: "app-info",
						label: "Informasi Aplikasi",
						children: <AppInformationTab />,
					},
				]}
			/>
		</Card>
	);
};

export default UserSettings;
